module.exports = __webpack_public_path__ + "static/media/measurement.e80db994.svg";